import './App.css'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import SignIn from './Components/Login/Login'
import { Components } from './Components/Components'

import { ThemeProvider } from '@mui/material'

import { theme } from './Components/theme'

import './Components/Localization/localization'
import PageNotFound from './404'

function App() {
	return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<Routes>
					<Route path='*' element={<PageNotFound />} />
					<Route path='/' element={<Navigate to='/login' />} />
					<Route path='/login' element={<SignIn />} />
					<Route path='/dashboard' element={<Components />} />
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	)
}

export default App
